<template>
    <pm-app-component hide-sidebar>
        <template slot="mobile-toolbar">
            <pm-application-bar simple>
                {{ $t('menu.history') }}
            </pm-application-bar>
        </template>

        <template v-if="loaded">
            <div id="main-container" class="app-content-container grey lighten-5" style="padding: 0!important; box-shadow: inset 0 8px 15px rgba(0,0,0,.03);">
                <div style="padding: 16px 16px 16px 20px; font-weight: 600; text-transform: uppercase; display: flex; align-items: center">
                    <span style="font-weight: 600; text-transform: uppercase; flex-grow: 1;">
                        Recent Plan
                    </span>
                    <v-btn class="roboto f13 black--text bold--text" flat style="margin: 0 12px 0 0; height: auto; border: 1px solid #0D47A1 !important; padding: 2px 8px 2px 16px; border-radius: 24px; margin-top: 0px;" @click.stop="$router.push('/plan')">
                        Continue
                        <v-icon style="margin-left: 2px;">
                            chevron_right
                        </v-icon>
                    </v-btn>
                </div>

                <div style="border-top: 1px solid #ccc; padding: 16px 16px 0px 16px; font-weight: 600; text-transform: uppercase;">{{ $t('menu.history') }}</div>
                <template v-if="items.length === 0">
                    <div style="text-align: center; padding-top: 25vh">
                        <svg style="width: 33vw"
                             version="1.1"
                             viewBox="0 0 32 32"
                             xmlns="http://www.w3.org/2000/svg"
                             xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                            <g fill-rule="evenodd" stroke="none" stroke-width="1" fill="#929292">
                                <path id="inbox" d="M12,16 L5.22497559,16 L9.59997559,9 L23.4000244,9 L27.7750244,16 L21,16 L21,17.9940809 C21,19.1134452 20.1057373,20 19.0026083,20 L13.9973917,20 C12.8958578,20 12,19.1019194 12,17.9940809 L12,16 L12,16 Z M4,16 L9,8 L24,8 L29,16 L29,17.5 L29,25 L4,25 L4,16 L4,16 Z" />
                            </g>
                        </svg>
                        <br>
                        <span class="roboto bold--text grey--text">{{ $t('history.no_saved_plans') }}</span>
                    </div>
                </template>
                <template v-else>
                    <template v-for="(item, i) in items">
                        <pm-plan-history
                            :key="item.id"
                            :index="item.id"
                            :plan-data="item.body"
                            :selected="i === selectedIndex"
                            @click.native="selectedIndex = i"
                            @open="load(item, i)"
                            @delete="deleteItem(item, i)"
                        />
                    </template>
                </template>
            </div>
        </template>

        <pm-app-loading-content-indicator v-else />

        <!-- <div class="premium--lock-down" v-if="!$IAP.hasAccessToComponent('history')" @click.stop="$bus.$emit('openAppDialog','premium', {'referrer': 'history'})" style="z-index: 3; display: flex; justify-content: center; align-items: center; position: absolute; right: 0px; top: 0px; left: 0; bottom: 0; cursor: pointer; background: rgba(150,150,150,.7); padding: 3px; border-radius: 3px;">
            <div @click.stop="$bus.$emit('openAppDialog','premium', {'referrer': 'history'})" style="font-size: 20px; padding-top: 5px; text-align: center; color: #fff!important; font-weight: 600; line-height: 2;">
                <mdi :size="50" style="color: #fff!important;">lock</mdi><br/>
                PREMIUM
            </div>
        </div> -->

        <pm-premium-lock-screen v-if="!$IAP.hasAccessToComponent('history')" />
    </pm-app-component>
</template>

<script>
import toolbarMixin from "../../extensions/mixins/mixin-toolbar";
import PmPlanHistory from "./plan";
import HistoryDB from "../../extensions/services/history-db";
import PmPremiumLockScreen from "@/components/core/premium-lock-screen";

export default {
    name: "PmModHistory",
    mixins: [toolbarMixin],
    components: {
        PmPlanHistory,
        PmPremiumLockScreen,
    },
    data: () => ({
        loaded: false,
        selectedIndex: -1,
        items: [],
    }),
    computed: {

    },
    async created() {

        // if (!window.IAP.hasAccessToComponent('history')) {
        //     // this.$bus.$emit('extra-features-dialog:show');
        //     this.$bus.$emit('openAppDialog','premium');
        //     return this.$router.push('/');
        // }

        this.items = await HistoryDB.getAll();
        this.loaded = true;
    },
    toolbar() {
        const items = [];

        items.push({
            placeholder: true,
        });

        items.push({
            placeholder: true,
        });

        items.push({
            placeholder: true,
        });

        items.push({
            back: true,
            callback: () => {
                this.$router.push("/");
            },
        });

        /*items.push({
            key: "category",
            icon: "close",
            text: this.$t("core.btn_close"),
            callback: () => {
                this.$router.push("/");
            },
        });*/


        return ([items]);
    },
    methods: {
        deleteItem(item, i) {
            this.items.splice(i, 1);
            HistoryDB.delete(item.id);
            CloudSaveManager.deleteCalc(item.date);

            window.Tracker.logEvent({
                event_name: "delete_history",
                event_category: "history",
                event_label: "Delete",
            });
        },

        load(item, i) {
            this.$set(this.$store.state, "currency", item.body.currency);
            this.$set(this.$store.state.localSettings, "currency", item.body.currency);

            const plan = JSON.parse(item.body.data);

            // @todo
            Object.keys(plan).forEach((key) => {
                this.$set(this.$store.state.simplePlan, key, plan[key]);
            });

            window.loadFromHistory = true;

            this.$bus.$emit("activePlan:update", {activePlan: i});

            window.Tracker.logEvent({
                event_name: "load_history",
                event_category: "history",
                event_label: "Load",
            });

            this.$router.push("/plan");
        },
    },
};
</script>
